module.exports = __webpack_public_path__ + "img/icon_3_18.687d6509.png";